export enum FixedComponentsCategoryEnum {
    MFG = "MFG",
    FIXED = "FIXED"
}